import { render, staticRenderFns } from "./CollectPayment.vue?vue&type=template&id=41dd9722&scoped=true"
import script from "./CollectPayment.vue?vue&type=script&lang=js"
export * from "./CollectPayment.vue?vue&type=script&lang=js"
import style0 from "./CollectPayment.vue?vue&type=style&index=0&id=41dd9722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd9722",
  null
  
)

export default component.exports